import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '@services/authentication.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class CustomerGuard {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        @Inject(PLATFORM_ID) private platformId: any
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        const currentUser = this.authenticationService.currentUserValue;
        
        if (currentUser?.type === 'C') {
            return true;
        } else if (currentUser && currentUser.type !== 'C') {
            // User is logged in but not a customer
            this.router.navigate(['/account/dashboard']);
            return false;
        } else if (isPlatformBrowser(this.platformId)) {
            // User is not logged in, check session
            return this.authenticationService.getUserDetails().pipe(
                map((response: any): any => {
                    if (response.data?.type === 'C') {
                        return true;
                    }
                    // Not a customer user, redirect to dashboard
                    this.router.navigate(['/account/dashboard']);
                    return false;
                })
            );
        } else {
            return false;
        }
    }
}
